var _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_176_1",
    "data-name": "Component 176 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 770.214,
    height: 773.016,
    viewBox: "0 0 770.214 773.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(35.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(93.642 58.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M161.4,176.567h0a59.357,59.357,0,0,1-59.357-59.357h0A59.357,59.357,0,0,1,161.4,57.853h0a59.358,59.358,0,0,1,59.359,59.357h0A59.358,59.358,0,0,1,161.4,176.567Z",
    transform: "translate(-102.047 -57.853)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(31.261 26.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 12.285,
    height: 39.686,
    transform: "translate(1.181 19.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M127.355,87.669a7.324,7.324,0,1,0-7.265-7.325A7.295,7.295,0,0,0,127.355,87.669Z",
    transform: "translate(-120.09 -73.022)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M144.178,103.841c0-5.579,2.568-8.9,7.485-8.9,4.517,0,6.688,3.191,6.688,8.9v20.833h12.227V99.546c0-10.631-6.026-15.77-14.439-15.77a13.837,13.837,0,0,0-11.96,6.556V84.987H132.4v39.687h11.783Z",
    transform: "translate(-111.075 -65.144)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M191.941,23.886l8.128,14.862,14.862,8.128L200.069,55l-8.128,14.862L183.813,55l-14.862-8.128,14.862-8.128Z",
    transform: "translate(40.609 -23.886)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M385.161,256.273l6.1,11.146,11.146,6.1-11.146,6.1-6.1,11.146-6.1-11.146-11.146-6.1,11.146-6.1Z",
    transform: "translate(186.372 146.36)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M391.112,224.508l2.75,5.029,5.029,2.75-5.029,2.75-2.75,5.029-2.75-5.029-5.029-2.75,5.029-2.75Z",
    transform: "translate(197.664 123.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M152,27.112l2.751,5.029,5.029,2.75-5.029,2.75L152,42.671l-2.75-5.029-5.029-2.75,5.029-2.75Z",
    transform: "translate(22.493 -21.523)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(0 438.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M84.615,311.385a17.97,17.97,0,0,0,10.493-16.761c-.088-9.926-7.7-17.91-17.012-17.832S61.315,284.979,61.4,294.9a17.938,17.938,0,0,0,10.955,16.638c-25.882,4.243-24.341,32.412-24.341,32.412l61.325-.511S110.372,314.934,84.615,311.385Z",
    transform: "translate(-48 -276.792)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(587.016 650.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M424.628,407.2a9.545,9.545,0,0,0-18.826.56,9.545,9.545,0,0,0-18.83-.4,12.885,12.885,0,0,0,2.313,9.3,38.36,38.36,0,0,0,6.731,7.114c3.427,3.049,6.594,5.917,10.021,8.966,3.4-3.079,6.291-5.974,9.69-9.053a38.179,38.179,0,0,0,6.669-7.175A12.883,12.883,0,0,0,424.628,407.2Z",
    transform: "translate(-386.806 -399.49)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(645.252 255.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(19.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M431.688,208.961l6.57-1.3,10.378-22.829-2.6-13.117s10.034-2.639,12.244,14.774,2.637,12.783,2.637,12.783,21.583-4.193,23.747-2.675c1.573,1.1,6.411,22.408,8.94,33.981,1.273,5.827-1.235,11.977-6.4,14.439a9.657,9.657,0,0,1-2.259.773c-5.38,1.067-33.73,2.143-33.73,2.143l-11.35,2.251Z",
    transform: "translate(-431.688 -171.569)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(0 35.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M420.418,194.126l12.955,44.142,11.254-2.232L435.893,192Z",
    transform: "translate(-420.418 -191.997)",
    fill: "#e0e0e0"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(0 771.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M794.986,469.514c0,.25-171.82.45-383.722.45-211.977,0-383.76-.2-383.76-.45s171.784-.451,383.76-.451C623.165,469.063,794.986,469.264,794.986,469.514Z",
    transform: "translate(-27.503 -469.063)",
    fill: "#263238"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(35.969 142.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(496.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M436.225,239.69h0a70.4,70.4,0,0,1-94.094-32.516h0a70.4,70.4,0,0,1,32.516-94.1h0a70.4,70.4,0,0,1,94.1,32.516h0A70.4,70.4,0,0,1,436.225,239.69Z",
    transform: "translate(-335.022 -105.973)",
    fill: "#f31322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M373.887,180.08a1.654,1.654,0,0,0,1.637-2.131c-.172-.852-.629-3-.806-3.895-.237-1.227-.534-1.549-1.792-2.1a13.868,13.868,0,0,1-6.968-7.086c-5.309-10.914-1.9-24.655,11.2-31.026,11.6-5.64,21.415-1.653,26.019,7.814,6.055,12.45,5.657,25.639-2.524,29.619-4.52,2.2-9.716.106-10.863-5-1.358-6.106-1.719-13.232-3.64-17.182-1.719-3.535-5.051-5.562-8.978-3.651-4.619,2.245-6.005,8.829-2.893,15.23a18.483,18.483,0,0,0,4.7,6.163s5.014,22.326,5.891,26.235c1.745,7.786,7.312,15.668,7.852,16.474a.639.639,0,0,0,1.147-.25c.156-.764,2.353-10.231.92-17.925-.4-2.178-2.732-13.348-2.732-13.348,2.892,2.133,8.5,2.517,13.166.251,13.885-6.754,17.148-23.99,8.907-40.931-6.23-12.811-22.881-19.464-39.373-11.444-20.519,9.98-23.711,29.723-17.743,41.991C360.631,175.312,366.659,180.553,373.887,180.08Z",
    transform: "translate(-320.872 -93.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(637.114 238.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M447.221,337.467h0A48.553,48.553,0,0,1,419.2,274.784h0a48.553,48.553,0,0,1,62.684-28.025h0A48.553,48.553,0,0,1,509.9,309.442v0A48.552,48.552,0,0,1,447.221,337.467Z",
    transform: "translate(-415.985 -243.548)",
    fill: "#19c919"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629",
    transform: "translate(14.18 22.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M483.9,291.005a26.154,26.154,0,0,0-48.646-19.1c-.146.35-.293.7-.428,1.055a25.76,25.76,0,0,0-1.286,13.857l-9.372,11.319,15.171.87a26.181,26.181,0,0,0,44.336-7.381C483.753,291.421,483.833,291.215,483.9,291.005Zm-32.436,11.666a21.9,21.9,0,0,1-10.009-7.689l-8.85-.5,5.453-6.592a21.6,21.6,0,0,1,.657-13.443,20.242,20.242,0,0,1,.858-1.939,21.994,21.994,0,0,1,40.754,16.018c-.156.544-.333,1.078-.539,1.615A21.923,21.923,0,0,1,451.464,302.671Z",
    transform: "translate(-424.169 -256.312)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M458.125,286.547c-.492-.528-2.881-3.093-3.356-3.5s-.835-.66-1.462-.218-2.294,1.338-2.786,1.6-.866.178-1.36-.35a17.378,17.378,0,0,1-3.687-4.789,19.037,19.037,0,0,1-1.759-5.378c-.116-.724.315-.927.726-1.111.379-.17.861-.469,1.3-.695.12-.073.223-.139.326-.2a6.979,6.979,0,0,0,.65-.565,1.146,1.146,0,0,0,.352-1.057c-.035-.355-.118-3.741-.166-5.122s-.619-1.363-.974-1.5-.721-.34-1.121-.494a2.374,2.374,0,0,0-1.885.132,7.123,7.123,0,0,0-3.988,4.163,8.1,8.1,0,0,0-.466,2.143,14.418,14.418,0,0,0,.567,4.933c.147.5,1.622,8.168,6.792,12.882,5.191,4.7,5.492,3.907,6.629,4.224s4.092-.074,5.116-1.282a5.246,5.246,0,0,0,1.433-2.689C458.95,287.373,458.605,287.072,458.125,286.547Z",
    transform: "translate(-413.719 -251.392)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(0 33.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M85.285,199.55h0a37.023,37.023,0,0,1-37.022-37.024h0A37.023,37.023,0,0,1,85.285,125.5h0a37.023,37.023,0,0,1,37.024,37.022h0A37.023,37.023,0,0,1,85.285,199.55Z",
    transform: "translate(-48.263 -125.504)",
    fill: "#4496e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M58.246,166.045a22.92,22.92,0,0,0,12.407,3.637c15.027,0,23.517-12.693,23.005-24.078a16.406,16.406,0,0,0,4.039-4.189,16.162,16.162,0,0,1-4.649,1.273,8.114,8.114,0,0,0,3.559-4.477,16.261,16.261,0,0,1-5.139,1.965,8.1,8.1,0,0,0-13.793,7.383A22.97,22.97,0,0,1,60.994,139.1a8.1,8.1,0,0,0,2.5,10.808,8.049,8.049,0,0,1-3.666-1.014,8.1,8.1,0,0,0,6.492,8.039,8.1,8.1,0,0,1-3.654.139,8.1,8.1,0,0,0,7.559,5.621A16.263,16.263,0,0,1,58.246,166.045Z",
    transform: "translate(-40.949 -116.628)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(24.998 396.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M141.249,460.809h0a63.765,63.765,0,0,1-76.806-47.251h0a63.766,63.766,0,0,1,47.253-76.808h0A63.767,63.767,0,0,1,188.5,384h0A63.765,63.765,0,0,1,141.249,460.809Z",
    transform: "translate(-62.691 -335)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(26.043 26.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M108.817,359.884c9.082-2.162,10.165-2.384,13.79-3.075a19.379,19.379,0,0,1,6.6-.333,11.582,11.582,0,0,1,7.992,4.917,19.411,19.411,0,0,1,2.675,6.036c1.017,3.548,1.31,4.616,3.472,13.7s2.384,10.165,3.075,13.791a19.384,19.384,0,0,1,.334,6.594,11.573,11.573,0,0,1-4.917,7.991,19.341,19.341,0,0,1-6.036,2.677c-3.548,1.017-4.614,1.308-13.7,3.472s-10.167,2.384-13.791,3.077a19.307,19.307,0,0,1-6.594.331,11.572,11.572,0,0,1-7.992-4.915,19.37,19.37,0,0,1-2.675-6.036c-1.019-3.548-1.31-4.616-3.472-13.7S85.191,384.246,84.5,380.62a19.369,19.369,0,0,1-.333-6.594,11.582,11.582,0,0,1,4.917-7.992,19.371,19.371,0,0,1,6.036-2.675c3.547-1.019,4.616-1.31,13.7-3.474m-1.459-6.126c-9.238,2.2-10.387,2.516-13.975,3.545a25.632,25.632,0,0,0-7.878,3.548,17.862,17.862,0,0,0-7.577,12.317,25.618,25.618,0,0,0,.385,8.632c.7,3.666.936,4.834,3.136,14.07s2.516,10.387,3.545,13.975a25.632,25.632,0,0,0,3.548,7.878,17.873,17.873,0,0,0,12.315,7.578,25.726,25.726,0,0,0,8.634-.386c3.666-.7,4.834-.936,14.07-3.136s10.385-2.516,13.975-3.545a25.65,25.65,0,0,0,7.878-3.548,17.872,17.872,0,0,0,7.578-12.317,25.717,25.717,0,0,0-.386-8.632c-.7-3.666-.936-4.834-3.136-14.07s-2.516-10.387-3.545-13.975a25.65,25.65,0,0,0-3.548-7.878,17.872,17.872,0,0,0-12.317-7.578,25.716,25.716,0,0,0-8.632.386c-3.668.7-4.834.936-14.07,3.136",
    transform: "translate(-77.722 -350.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M102.936,361.941a17.953,17.953,0,1,0,21.625,13.3,17.952,17.952,0,0,0-21.625-13.3m6.861,28.8a11.654,11.654,0,1,1,8.635-14.038,11.653,11.653,0,0,1-8.635,14.038",
    transform: "translate(-69.358 -341.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M113.342,359.64a4.2,4.2,0,1,1-5.054-3.11,4.2,4.2,0,0,1,5.054,3.11",
    transform: "translate(-57.692 -345.354)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(556.825 407.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M399.381,400.37h0a29.738,29.738,0,0,1-29.737-29.738h0a29.736,29.736,0,0,1,29.737-29.737h0a29.736,29.736,0,0,1,29.737,29.737h0A29.738,29.738,0,0,1,399.381,400.37Z",
    transform: "translate(-369.644 -340.895)",
    fill: "#1d66af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M385.783,383.634h7.239V365.506h5.051l.539-6.069h-5.589V355.98c0-1.431.288-2,1.672-2h3.917v-6.3H393.6c-5.387,0-7.816,2.374-7.816,6.913v4.839h-3.765v6.146h3.765Z",
    transform: "translate(-360.579 -335.921)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(230.197 69.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M451.277,767.363l-238.9-.14a52.04,52.04,0,0,1-52.009-52.051l.118-598.934a52.041,52.041,0,0,1,52.07-52.032l238.9.142A52.04,52.04,0,0,1,503.466,116.4l-.118,598.935A52.037,52.037,0,0,1,451.277,767.363Z",
    transform: "translate(-160.365 -64.207)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(15.831 21.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M444.509,76.574l-46.319-.026A11.505,11.505,0,0,0,386.941,88.3l0,8.4a11.505,11.505,0,0,1-11.248,11.75L285.4,108.4a11.516,11.516,0,0,1-11.245-11.764l0-8.4a11.516,11.516,0,0,0-11.246-11.764l-16.29-.01-40.539-.023a36.445,36.445,0,0,0-36.468,36.438l-.114,584.6a36.447,36.447,0,0,0,36.424,36.456l238.426.139a36.446,36.446,0,0,0,36.466-36.438l.114-584.6A36.446,36.446,0,0,0,444.509,76.574Z",
    transform: "translate(-169.502 -76.435)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(267.416 68.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M341.618,104.009c0,.156-6.021.333-13.452.4s-13.455-.016-13.457-.173,6.021-.333,13.454-.4S341.618,103.851,341.618,104.009Z",
    transform: "translate(-314.709 -103.815)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(0.057 6.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M341.651,107.983c0,.156-6.022.333-13.452.4s-13.455-.017-13.457-.173,6.021-.334,13.452-.4S341.649,107.825,341.651,107.983Z",
    transform: "translate(-314.742 -107.789)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(0.114 13.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M341.684,111.956c0,.158-6.023.334-13.452.4s-13.457-.016-13.457-.172,6.021-.334,13.452-.4S341.682,111.8,341.684,111.956Z",
    transform: "translate(-314.775 -111.763)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(40.622 60.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M184.171,127.753a5.527,5.527,0,0,1,.705-.047l1.961-.064,7.242-.173-.2.2q-.039-2.409-.085-5.252c.01-.975-.083-1.9.01-3.023a2.785,2.785,0,0,1,2.431-2.232c1.166-.023,2.193-.076,3.458-.017a2.812,2.812,0,0,1,2.375,2.8c.028,2.448.057,5.005.087,7.658l-.336-.329c2.933-.031,5.988-.061,9.134-.094l-.347.353c-.033-3.678-.068-7.483-.1-11.381q-.01-1.458-.024-2.9A2.952,2.952,0,0,0,209.2,111.1l-3.994-3.936q-1.962-1.934-3.852-3.8-.943-.93-1.868-1.843c-.641-.619-1.145-1.258-1.889-1.41a2.461,2.461,0,0,0-2.1.4c-.553.468-1.142,1.13-1.7,1.672q-1.687,1.7-3.278,3.306c-2.062,2.142-4.208,4.1-5.77,5.948-.658,1.021-.412,2.271-.459,3.408q-.005,1.7-.007,3.219-.018,2.96-.033,5.186c-.016,1.324-.028,2.419-.036,3.314a11.759,11.759,0,0,1-.045,1.2,8.685,8.685,0,0,1-.062-1.1c-.024-.882-.055-1.96-.092-3.264q-.049-2.24-.118-5.226-.029-1.552-.061-3.283-.013-.876-.028-1.795a3.8,3.8,0,0,1,.5-1.913c1.689-2.07,3.706-3.9,5.783-6.107q1.578-1.614,3.252-3.332c.586-.575,1.066-1.147,1.764-1.746a3.1,3.1,0,0,1,2.647-.521,4.932,4.932,0,0,1,2.193,1.568l1.875,1.837q1.895,1.858,3.865,3.789t4,3.928a7.611,7.611,0,0,1,1.02,1.105,2.992,2.992,0,0,1,.478,1.54q.013,1.448.026,2.912c.029,3.9.059,7.7.087,11.383l0,.35-.35,0-9.136.059-.334,0,0-.333c-.014-2.651-.026-5.21-.04-7.658a2.2,2.2,0,0,0-1.845-2.218c-1.052-.055-2.29-.019-3.313-.01a2.242,2.242,0,0,0-1.97,1.776c-.088.918-.021,1.989-.04,2.919q0,2.838,0,5.252v.2h-.2c-3.02-.023-5.48-.04-7.362-.052-.743-.014-1.374-.024-1.916-.033A3.592,3.592,0,0,1,184.171,127.753Z",
    transform: "translate(-183.811 -99.366)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(34.843 524.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(100.033 20.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M301.917,379.6a13.27,13.27,0,0,1-2.5.177c-1.783.036-4.075.085-6.826.144-5.764.081-13.727.132-22.522.132s-16.761-.05-22.524-.132c-2.751-.059-5.045-.107-6.826-.144a13.269,13.269,0,0,1-2.5-.177,13.387,13.387,0,0,1,2.5-.175l6.826-.144c5.763-.081,13.727-.132,22.524-.132s16.758.05,22.522.132l6.826.144A13.387,13.387,0,0,1,301.917,379.6Z",
    transform: "translate(-238.211 -379.146)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(0 15.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M402.046,388.643c0,.249-36.679.45-81.914.45-45.25,0-81.921-.2-81.921-.45s36.67-.451,81.921-.451C365.367,388.192,402.046,388.393,402.046,388.643Z",
    transform: "translate(-238.211 -388.192)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(0 30.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M350.847,397.153c0,.248-25.216.45-56.315.45s-56.322-.2-56.322-.45,25.211-.452,56.322-.452S350.847,396.9,350.847,397.153Z",
    transform: "translate(-238.211 -396.701)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(257.17 65.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M338.842,419.821l-5.09-5.106-4.846,4.834.023-14.614,9.936.016Zm-5.089-5.742.159.159,4.481,4.5.021-13.336-9.037-.014-.021,13.079Z",
    transform: "translate(-328.905 -404.934)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(122.41 68.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M260.278,416.688l-1.795-.8a4.921,4.921,0,1,1,2.623-4.323,4.974,4.974,0,0,1-1.242,3.327Zm-4.2-9.73a4.648,4.648,0,1,0,.075,9.3,4.794,4.794,0,0,0,2.237-.705l.075-.043,1.325.593-.3-1.3.061-.066a4.641,4.641,0,0,0-3.47-7.771Z",
    transform: "translate(-251.126 -406.616)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(137.191 69.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M265.577,415.628l-2.06-5.025-3.86-3.519,9.365-.075Zm-5.045-8.207,3.289,3.018,1.753,4.279,2.942-7.362Z",
    transform: "translate(-259.657 -407.01)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(141.262 69.047)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 6.091,
    height: 0.342,
    transform: "translate(0 3.322) rotate(-33.054)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(105.352 67.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M252.756,408.643a2.9,2.9,0,0,0-5.712.191,2.9,2.9,0,0,0-5.714-.1,3.91,3.91,0,0,0,.712,2.819,11.632,11.632,0,0,0,2.05,2.15c1.043.922,2.008,1.788,3.051,2.71,1.027-.937,1.9-1.819,2.93-2.758a11.518,11.518,0,0,0,2.017-2.183A3.919,3.919,0,0,0,252.756,408.643Z",
    transform: "translate(-241.281 -406.316)",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M458.015,460.424s-.021-.561-.031-1.63q-.01-1.627-.031-4.74c-.017-4.181-.042-10.33-.073-18.293-.038-15.924-.094-39.091-.163-68.152l.3.3-277.072.154h-.017l.452-.452c-.005,32.256-.01,63.545-.016,92.815l-.437-.437c79.762.081,148.972.151,198.268.2l57.877.121,15.533.057,4.025.028c.908.009,1.386.028,1.386.028s-.44.017-1.331.028q-1.37.008-3.975.028l-15.437.055-57.779.123-198.568.2h-.437v-.437c-.005-29.271-.009-60.56-.014-92.815v-.451h.468c110.9.062,210.407.116,277.072.154h.3l0,.3c-.069,29.137-.125,52.364-.163,68.33-.031,7.935-.056,14.06-.073,18.225q-.021,3.077-.031,4.688C458.034,459.9,458.015,460.424,458.015,460.424Z",
    transform: "translate(-180.475 -367.158)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(11.166 15.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 61.363,
    height: 76.754,
    transform: "matrix(0.006, -1, 1, 0.006, 0.459, 61.769)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M264.48,376.978a3.009,3.009,0,0,1-.385.021l-1.088.017-4.189.024-15.737.017-55.355-.113.405-.4c-.09,18.27-.192,39.2-.3,61.357.1.107-.84-.854-.435-.449l.021,0h.125l.168,0,.333,0,.664,0,1.329.007,2.646.016,5.253.031,10.342.062,19.913.128,35.946.26-.378.372c.185-18.424.34-33.711.447-44.443.073-5.336.128-9.538.168-12.457q.039-2.116.061-3.3c.019-.75.048-1.157.048-1.157s.026.353.035,1.078q.01,1.162.024,3.23c.007,2.9.016,7.074.028,12.374-.016,10.789-.036,26.157-.061,44.682v.374l-.378,0-35.945-.149-19.914-.1-10.342-.055q-2.612-.013-5.253-.029l-2.646-.014-1.329-.007-.664-.005-.333,0h-.251l-.042,0h-.021c.4.405-.563-.549-.463-.459.144-22.153.279-43.086.4-61.355l0-.405.4,0,55.615.518,15.645.2,4.11.071,1.043.029A1.492,1.492,0,0,1,264.48,376.978Z",
    transform: "translate(-186.92 -376.134)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 53.637,
    height: 71.361,
    transform: "matrix(0.006, -1, 1, 0.006, 3.127, 57.921)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M188.725,423.6l25.113-33.2,15.321,20.946,10.535-11.091,20.391,23.748Z",
    transform: "translate(-185.597 -365.68)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(39.02 15.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M220.679,390.507a5.619,5.619,0,1,1-5.588-5.65A5.622,5.622,0,0,1,220.679,390.507Z",
    transform: "translate(-209.441 -384.857)",
    fill: "#f5f5f5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(45.971 130.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(49.602 12.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M296.2,147.062a2.834,2.834,0,0,1-.819.092l-2.349.085-8.644.142c-7.3.083-17.383.133-28.52.133s-21.224-.05-28.524-.133c-3.54-.057-6.457-.106-8.642-.142l-2.351-.085a2.834,2.834,0,0,1-.82-.092,2.887,2.887,0,0,1,.82-.09c.643-.024,1.419-.052,2.351-.085l8.642-.144c7.3-.081,17.385-.132,28.524-.132s21.221.05,28.52.132l8.644.144c.932.033,1.707.061,2.349.085A2.886,2.886,0,0,1,296.2,147.062Z",
    transform: "translate(-215.527 -146.612)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(0 328.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(228.895 1.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M333.776,352.007l-7.563-7.587-7.2,7.183.035-21.718,14.767.023Zm-7.561-8.531.236.234,6.66,6.683.031-19.818-13.431-.021-.031,19.438Z",
    transform: "translate(-319.009 -329.885)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(33.576 1.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M224.291,349.717l-3.536-1.577a9.685,9.685,0,1,1,5.165-8.507,9.787,9.787,0,0,1-2.445,6.549Zm-8.266-19.152a9.148,9.148,0,1,0,.147,18.3,9.429,9.429,0,0,0,4.406-1.39l.146-.081,2.606,1.163-.589-2.561.118-.13a9.138,9.138,0,0,0-6.833-15.3Z",
    transform: "translate(-206.277 -329.892)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(62.67 2.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M234.721,347.632l-4.053-9.891-7.6-6.925,18.431-.147Zm-9.931-16.158,6.473,5.941,3.451,8.426,5.79-14.493Z",
    transform: "translate(-223.069 -330.668)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(70.683 2.367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 11.99,
    height: 0.673,
    transform: "matrix(0.838, -0.545, 0.545, 0.838, 0, 6.539)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M209.482,333.882a5.7,5.7,0,0,0-11.243.376,5.7,5.7,0,0,0-11.246-.194,7.693,7.693,0,0,0,1.4,5.546,22.772,22.772,0,0,0,4.035,4.234c2.053,1.814,3.95,3.521,6,5.335,2.024-1.847,3.746-3.581,5.77-5.428a22.852,22.852,0,0,0,3.968-4.3A7.694,7.694,0,0,0,209.482,333.882Z",
    transform: "translate(-186.898 -329.301)",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 12.503,
    cy: 12.503,
    r: 12.503,
    transform: "translate(8.401)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(4.756 260.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(0 19.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M423.828,301.446c0,.249-52.428.45-117.087.45-64.681,0-117.1-.2-117.1-.45s52.416-.452,117.1-.452C371.4,300.994,423.828,301.2,423.828,301.446Z",
    transform: "translate(-189.643 -300.994)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M423.828,290.19c0,.25-52.428.452-117.087.452-64.681,0-117.1-.2-117.1-.452s52.416-.451,117.1-.451C371.4,289.739,423.828,289.94,423.828,290.19Z",
    transform: "translate(-189.643 -289.739)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(0 39.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M317.112,312.85c0,.249-28.538.452-63.732.452s-63.737-.2-63.737-.452,28.531-.45,63.737-.45S317.112,312.6,317.112,312.85Z",
    transform: "translate(-189.643 -312.4)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    transform: "translate(152.515 637.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M258.342,437.434a4.976,4.976,0,1,1-4.954-5.071A5.01,5.01,0,0,1,258.342,437.434Z",
    transform: "translate(-248.392 -432.363)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(15.417 0.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M267.24,437.475a4.976,4.976,0,1,1-4.953-5.071A5.009,5.009,0,0,1,267.24,437.475Z",
    transform: "translate(-257.29 -432.404)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(30.833 0.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M276.138,437.516a4.976,4.976,0,1,1-4.953-5.071A5.006,5.006,0,0,1,276.138,437.516Z",
    transform: "translate(-266.188 -432.445)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(36.954 167.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 277.09,
    height: 169.454,
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M196.457,303.912l79.4-106.274L325.083,264.1l33.363-35.547,65.434,75.294Z",
    transform: "translate(-170.878 -134.426)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(139.255 32.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M297.882,197.682a17.907,17.907,0,1,1-17.913-17.9A17.907,17.907,0,0,1,297.882,197.682Z",
    transform: "translate(-262.067 -179.781)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(35.757 111.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M458.543,512.124c0-3.625-.168-156.7-.409-383.32l.409.411-277.057.042h-.031l.45-.452c-.031,143.354-.061,276.022-.085,383.32l-.366-.367,277.088.367c-3.022.005-109.057.146-277.088.367h-.367v-.367c-.024-107.3-.054-239.967-.085-383.32v-.45h.483c99.306.014,193.5.029,277.057.042h.409v.409c-.083,113.419-.152,209.291-.2,276.823-.047,33.716-.083,60.355-.109,78.577-.021,9.086-.038,16.072-.049,20.8q-.015,3.519-.024,5.335C458.559,511.53,458.543,512.124,458.543,512.124Z",
    transform: "translate(-181.003 -128.353)",
    fill: "#263238"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Megaphone",
    transform: "translate(116.957 171.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(184.081 346.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M313.509,417.069l6.13-20.6c1.069-4.467,2.49-9.735,4.4-15.748,1.719-5.4,6.127-11.082,10.146-15.171,6.258-6.364,9.233-6.407,13.44-9.784.383-.246.809-.6,1.171-.792a6.634,6.634,0,0,0,2.044-1.769c3.625-3.921.144-9.988-7.216-9.411-5.543.435-14.58,2.02-29.274,17.18-.184.23-.376.423-.556.658-7.714,10.025-14.956-18.594-16.262-29.246-.847-6.911-8.325-11.16-15.089-8.66l-35.8,16.744c-2.956-1.041-6.466-.865-10.449.353a10.64,10.64,0,0,0-6.82,12.629L243.9,411.415,201.252,553.3h91.913Z",
    transform: "translate(-201.252 -323.009)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(205.638 290.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M375,310.554,346.59,366.228l-14.206-3.947L260.975,420.37a14.465,14.465,0,0,1-20.093-1.786L213.694,386.99s54.821-23.617,64.96-43.164-1.577-23.983-1.577-23.983l25.8-29.321Z",
    transform: "translate(-213.694 -290.522)",
    fill: "#ef5a2a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M425.1,319.51s-41.589-9.2-100.115-65.478S238.964,123.018,231.8,123.382s-38.443-14.157-97.933,115.253S97.809,398.1,109.646,397.853s92.221-22.643,142.428-16.936,114.741,31.875,114.741,31.875Z",
    transform: "translate(-95.007 -123.056)",
    fill: "#ef5a2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(262.867 172.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M402.3,317.292l-14.188,26.977-6.357,12.083a35.207,35.207,0,0,1-45.893,15.592l-89.141-31.059,51.914-118.517L387.7,269.829A35.21,35.21,0,0,1,402.3,317.292Z",
    transform: "translate(-246.725 -222.368)",
    fill: "#ef5a2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(262.867 172.068)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M402.3,317.292l-14.188,26.977-6.357,12.083a35.207,35.207,0,0,1-45.893,15.592l-89.141-31.059,51.914-118.517L387.7,269.829A35.21,35.21,0,0,1,402.3,317.292Z",
    transform: "translate(-246.725 -222.368)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(7.79 2.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M135.378,239.736c-31.66,70.1-44.84,132.57-29.437,139.528s53.556-44.235,85.218-114.336S236,132.358,220.6,125.4,167.042,169.633,135.378,239.736Z",
    transform: "translate(-99.503 -124.769)",
    fill: "#ef5a2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(7.79 3.99)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M135.378,239.736c-31.66,70.1-44.84,132.57-29.437,139.528s53.556-44.235,85.218-114.336S236,132.358,220.6,125.4,167.042,169.633,135.378,239.736Z",
    transform: "translate(-99.503 -124.769)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(401.935 269.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M351.152,314.881l-24.161-7.588,14.951-28.429,18.12,11.264Z",
    transform: "translate(-326.991 -278.865)",
    fill: "#ef5a2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(401.935 269.954)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M341.942,278.865l-14.951,28.429,4.965,1.561,12.156-28.641Z",
    transform: "translate(-326.991 -278.865)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(347.646 252.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M348.251,292.735c-.355.781-12.414-3.905-26.93-10.468s-26.012-12.518-25.656-13.3,12.407,3.907,26.931,10.47S348.6,291.955,348.251,292.735Z",
    transform: "translate(-295.656 -268.884)",
    fill: "#fb8661"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(360.286 236.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M350.335,282.779c-.381.771-11.291-3.829-24.372-10.271s-23.381-12.289-23-13.06,11.284,3.833,24.371,10.276S350.713,282.009,350.335,282.779Z",
    transform: "translate(-302.952 -259.364)",
    fill: "#fb8661"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(342.921 272.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M340.875,301.949c-.128.412-3-.251-7.577-1.665-2.287-.707-5-1.6-8-2.639-2.978-1.079-6.071-2.644-9.386-4.144-13.218-6.137-23.31-12.144-22.979-12.856.39-.84,11.179,3.959,24.274,10.035,3.285,1.488,6.333,3.127,9.205,4.328,2.883,1.166,5.47,2.254,7.629,3.212C338.368,300.14,341,301.538,340.875,301.949Z",
    transform: "translate(-292.929 -280.549)",
    fill: "#fb8661"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(46.59 97.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M183.522,184.3s-36.147-22.415-55.925,26.422,18.255,56.867,18.255,56.867C161.416,243.453,174.059,215.794,183.522,184.3Z",
    transform: "translate(-121.897 -179.163)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(43.091 44.141)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M223.445,148.533c.211.036-.3,3.353-1.416,9.33-1.144,5.969-2.76,14.632-5.078,25.266-1.528,5.239-3.2,10.959-4.99,17.09q-1.359,4.61-2.809,9.519-.728,2.456-1.474,4.976c-.541,1.669-1.244,3.306-1.873,4.992-2.6,6.719-5.335,13.767-8.166,21.07q-1.066,2.742-2.152,5.527c-.7,1.866-1.7,3.621-2.542,5.458q-2.651,5.465-5.371,11.078t-5.39,11.075c-.922,1.8-1.691,3.668-2.72,5.376L176.45,284.4l-11.518,19.45c-.939,1.537-1.788,3.1-2.767,4.557q-1.52,2.152-3,4.245-2.965,4.176-5.756,8.107c-3.718,5.2-7.187,10.058-10.363,14.5-6.911,8.375-12.709,14.982-16.69,19.568-4.006,4.565-6.3,7.024-6.464,6.887s1.814-2.855,5.532-7.656l15.924-20.19,9.975-14.616q2.7-3.932,5.576-8.119l2.919-4.24c.951-1.457,1.781-3.025,2.694-4.562l11.286-19.41,2.97-5.087c1.017-1.7,1.772-3.555,2.685-5.347q2.63-5.429,5.335-11l5.349-10.993c.844-1.821,1.838-3.564,2.542-5.413q1.089-2.76,2.162-5.477c2.869-7.232,5.64-14.211,8.278-20.864.643-1.669,1.362-3.285,1.92-4.934q.774-2.5,1.53-4.924,1.513-4.852,2.938-9.415c1.911-6.061,3.692-11.714,5.328-16.891,2.512-10.42,4.557-18.9,6.014-24.946C222.318,151.74,223.235,148.5,223.445,148.533Z",
    transform: "translate(-119.877 -148.533)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(214.299 333.226)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M218.693,364.9c3.3,5.986,6.662,12.066,11.543,16.85s11.581,8.173,18.379,7.488,13.242-6.333,13.315-13.166c3.264,2.453,8.266,1.125,10.969-1.935s3.581-7.31,3.905-11.378c4.432,2.614,10.6.541,13.554-3.67s3.141-9.883,1.708-14.826-4.3-9.327-7.116-13.629c3.411.275,7.027.513,10.08-1.034s5.116-5.586,3.334-8.511c-1.045-1.715-3.051-2.568-4.969-3.169-5.349-1.674-9.1-3.015-14.668-2.368-1.294.014,2.228,14.685-32.718,34.754C225.379,362.151,218.693,364.9,218.693,364.9Z",
    transform: "translate(-218.693 -315.383)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(257.494 403.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M279.123,356.547c-.023.161-2.349-.286-6.12-.184a34.6,34.6,0,0,0-25.684,12.314c-2.439,2.876-3.548,4.969-3.689,4.886a5.353,5.353,0,0,1,.684-1.516,27.669,27.669,0,0,1,2.511-3.774A32.735,32.735,0,0,1,273,355.725a27.907,27.907,0,0,1,4.515.4A5.332,5.332,0,0,1,279.123,356.547Z",
    transform: "translate(-243.624 -355.72)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M220.008,351.6c5.629,5.407,9.479,11.378,15.384,16.824,2.682,2.474,6.851,7.163,10.448,7.786s5.9.146,7.324-3.216c1.152-2.722-.918-6.442-2.348-8.685-3.761-5.9-7.358-10.513-10.176-15.1-1.32-2.148.388-2.592,1.012-1.6,2.71,2.809,6.75,5.243,9.178,8.3,3.323,4.188,3.926,9.732,12.622,7.979a7.835,7.835,0,0,0,3.228-1.341c3.273-2.505,3.41-6.861,2.032-10.35a28.332,28.332,0,0,0-4.841-7.324c3.7,4.179,7.741,8.58,13.627,9.055a8.107,8.107,0,0,0,8.24-4.46c1.741-3.954-.755-7.776-3.261-10.867A113.188,113.188,0,0,0,267.7,323.5a11.243,11.243,0,0,0-7.183-2.663c-3.042-.021-6.852.553-8.734,3.2-3.415,4.806-2.363,9.056-2.363,9.056s-7.634-3.871-13.767.177A19.453,19.453,0,0,0,228,344.277Z",
    transform: "translate(-3.431 21.838)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M244.371,326.845c-2.362-2.379-2.913-6.731-1.079-10.326,1.3-2.544,2.937-5.016,4.6-5.577,7.261-2.45,38.987,3.039,38.7,10.082-.3,7.23-2.606,10.411-19.824,7.925-3.029-.437-7.781-1.034-7.781-1.034l-4.155,6.237Z",
    transform: "translate(12.827 14.154)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(245.395 354.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M254.125,343.6c-.251.154-2.666-4.773-7.594-9.188-4.879-4.475-10.016-6.4-9.888-6.662A10.141,10.141,0,0,1,240,328.93a30.132,30.132,0,0,1,12.619,11.439A10.139,10.139,0,0,1,254.125,343.6Z",
    transform: "translate(-236.641 -327.729)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(257.758 342.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M254.237,327.017c-.159.147-2.252-1.561-5.109-3.309a35.925,35.925,0,0,0-3.723-2.053c-.981-.461-1.63-.587-1.629-.722-.005-.114.747-.208,1.849.125a17.054,17.054,0,0,1,3.978,1.883C252.531,324.73,254.449,326.826,254.237,327.017Z",
    transform: "translate(-243.776 -320.826)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(262.363 338.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M257.616,322.389c-.021.191-2.784.27-6.111-.688a11.168,11.168,0,0,1-3.91-2.05c-.871-.741-1.234-1.36-1.149-1.435.168-.154,2.138,1.72,5.326,2.621C254.919,321.751,257.663,322.091,257.616,322.389Z",
    transform: "translate(-246.434 -318.208)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(217.502 363.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M245.75,348.6a22.091,22.091,0,0,1-2.892-3.76c-1.7-2.346-3.871-5.844-7.407-8.417a14.928,14.928,0,0,0-10.489-2.779c-2.847.4-4.332,1.571-4.418,1.405-.031-.04.3-.362,1.012-.8a9.875,9.875,0,0,1,3.3-1.234,14.739,14.739,0,0,1,11.118,2.675c3.735,2.731,5.841,6.369,7.412,8.8A28.186,28.186,0,0,1,245.75,348.6Z",
    transform: "translate(-220.542 -332.796)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    transform: "translate(240.948 449.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M260.108,382.448c.026.248-5.78,1.083-12.968,1.864s-13.038,1.215-13.066.967,5.778-1.083,12.969-1.864S260.08,382.2,260.108,382.448Z",
    transform: "translate(-234.074 -382.378)",
    fill: "#eb996e"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Stars",
    transform: "translate(36.744 44.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M408.971,49.844l1.956,3.576,3.576,1.956-3.576,1.956-1.956,3.576-1.956-3.576-3.576-1.956,3.576-1.956Z",
    transform: "translate(211.163 -49.844)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M432.576,101.014l1.956,3.576,3.576,1.956-3.576,1.956-1.956,3.576L430.62,108.5l-3.576-1.956,3.576-1.956Z",
    transform: "translate(228.456 -12.356)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M54.242,237.533,56.2,241.11l3.576,1.956L56.2,245.021,54.242,248.6l-1.956-3.577-3.576-1.956,3.576-1.956Z",
    transform: "translate(-48.711 87.658)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M381.063,62.562l4.517,8.258,8.258,4.517-8.258,4.517-4.517,8.258-4.517-8.258-8.258-4.517,8.258-4.517Z",
    transform: "translate(185.412 -40.526)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M78.451,205.1l4.507,8.24,8.24,4.507-8.24,4.507-4.507,8.24-4.506-8.24-8.24-4.507,8.24-4.507Z",
    transform: "translate(-36.261 63.895)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M442.048,318.565l4.507,8.24,8.24,4.507-8.24,4.507-4.507,8.24-4.507-8.24-8.24-4.507,8.24-4.507Z",
    transform: "translate(230.109 147.022)",
    fill: "#e8505b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.52bf28b48ce3cfffb61e4895cef662e1.svg";
export { ForwardRef as ReactComponent };